export default "__VITE_ASSET__BWUv_Fzd__"